import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import {
  selectCurrentUserIsAdminOrOwner,
  selectDaysLeftInTrial,
  selectIsTrialSubscription,
} from '@ninety/platform/state';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { selectIsFreemiumPlan } from '@ninety/platform/state/app-global/billing/billing-state.selectors';
import { TerraIconModule } from '@ninety/terra';
import { ButtonComponent, CardComponent, NinetyCmButtonComponent } from '@ninety/ui/core';

import { GuideActions } from '../../_state/guide.actions';
import { GuideSelectors } from '../../_state/guide.selectors';
import { Phase } from '../../models/phase';
import { PhaseComponent } from '../phase/phase.component';

@Component({
  selector: 'ninety-phase-list',
  templateUrl: './phase-list.component.html',
  styleUrls: ['./phase-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LetDirective, ButtonComponent, TerraIconModule, CardComponent, NinetyCmButtonComponent, PhaseComponent],
})
export class PhaseListComponent {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  protected readonly title$ = this.store.select(GuideSelectors.selectTitle);
  protected readonly subtitle$ = this.store.select(GuideSelectors.selectSubtitle);
  protected readonly phases$ = this.store.select(GuideSelectors.selectPhases);
  protected readonly isTrialing$ = this.store.select(selectIsTrialSubscription);
  protected readonly daysLeftInTrial$ = this.store.select(selectDaysLeftInTrial);
  protected readonly isAdminOrOwner$ = this.store.select(selectCurrentUserIsAdminOrOwner);
  protected readonly isFreeTier$ = this.store.select(selectIsFreemiumPlan);

  close(): void {
    this.store.dispatch(GuideActions.closeGuide());
  }

  selectPhase(phase: Phase): void {
    if (phase.locked) return;
    this.store.dispatch(GuideActions.selectPhase({ phase }));
  }

  openPricingTierDialog(): void {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
